import { formatCents } from "@shared/money";
import { Text, type TextProps } from "./Text";

export type MoneyTextProps = Omit<TextProps, "children" | "tabular"> & { cents: number; /** Show a leading + on positive amounts. */ sign?: boolean };

/** Cents → "$1,234.50" with tabular figures (SPEC §6.2). */
export function MoneyText({ cents, sign, as = "span", ...rest }: MoneyTextProps) {
  return (
    <Text as={as} tabular {...rest}>
      {formatCents(cents, { sign })}
    </Text>
  );
}
